import React, { useCallback } from 'react';

import { FaPencilAlt as PencilIcon, FaTrash as TrashIcon } from 'react-icons/fa';

import { TlsAccount } from '@common/schemas/tlsAccount';

type TlsAccountsAdminColumnRendererProps = {
  value: TlsAccount,
  rowIndex: number,
}

export const TlsAccountsAdminColumnRendererFactory = ({
  showModalForEdit,
  showModalForRemove,
}: {
  showModalForEdit: (entity: TlsAccount) => void,
  showModalForRemove: (data: { entityToRemove: TlsAccount, rowIndex: number }) => void,
}) => {
  const TlsAccountsAdminColumnRenderer: React.FC<TlsAccountsAdminColumnRendererProps> = ({
    value: entity,
    rowIndex,
  }: TlsAccountsAdminColumnRendererProps) => {
    const showEditModal = useCallback(() => {
      showModalForEdit(entity);
    }, [entity]);

    const showRemoveModal = useCallback(() => {
      showModalForRemove({ entityToRemove: entity, rowIndex });
    }, [entity, rowIndex]);


    return (
      <div>
        <button
          className="cell-icon-button"
          title="Edit TLS Account Settings"
          onClick={showEditModal}
        >
          <PencilIcon size={16} className="cell-icon" />
        </button>

        <button
          className="cell-icon-button"
          title="Remove TLS Account Settings"
          onClick={showRemoveModal}
        >
          <TrashIcon size={16} className="cell-icon" />
        </button>
      </div>
    );
  };


  return TlsAccountsAdminColumnRenderer;
};

